export class PoliceManifestationGeneral {
    get id() {
        return this.policeManifestationGeneralState.id;
    }
    get ndiligencia() {
        return this.policeManifestationGeneralState.ndiligencia;
    }
    get userId() {
        return this.policeManifestationGeneralState.userId;
    }
    get ocularInspection() {
        return this.policeManifestationGeneralState.ocularInspection;
    }
    get eyeInspectionResult() {
        return this.policeManifestationGeneralState.eyeInspectionResult;
    }
    get samplesInvolved() {
        return this.policeManifestationGeneralState.samplesInvolved;
    }
    get sampleTypes() {
        return this.policeManifestationGeneralState.sampleTypes;
    }
    get weaponsIntervene() {
        return this.policeManifestationGeneralState.weaponsIntervene;
    }
    get typesWeapons() {
        return this.policeManifestationGeneralState.typesWeapons;
    }
    get armsWithdrawalProcedure() {
        return this.policeManifestationGeneralState.armsWithdrawalProcedure;
    }
    get interestingData() {
        return this.policeManifestationGeneralState.interestingData;
    }
    get transferHealthCenter() {
        return this.policeManifestationGeneralState.transferHealthCenter;
    }
    get accompanyAddressEffects() {
        return this.policeManifestationGeneralState.accompanyAddressEffects;
    }
    get accompanyFamilyHome() {
        return this.policeManifestationGeneralState.accompanyFamilyHome;
    }
    get transferReceptionCenter() {
        return this.policeManifestationGeneralState.transferReceptionCenter;
    }
    get observations() {
        return this.policeManifestationGeneralState.observations;
    }
    get referralDate() {
        return this.policeManifestationGeneralState.referralDate;
    }
    get numFoliosRemission() {
        return this.policeManifestationGeneralState.numFoliosRemission;
    }
    get numReferralMinutes() {
        return this.policeManifestationGeneralState.numReferralMinutes;
    }
    get independentMinutes() {
        return this.policeManifestationGeneralState.independentMinutes;
    }
    get numCitations() {
        return this.policeManifestationGeneralState.numCitations;
    }
    get citations() {
        return this.policeManifestationGeneralState.citations;
    }
    get bodyTransfer() {
        return this.policeManifestationGeneralState.bodyTransfer;
    }
    set id(id) {
        this.policeManifestationGeneralState.id = id;
    }
    set ndiligencia(ndiligencia) {
        this.policeManifestationGeneralState.ndiligencia = ndiligencia;
    }
    set userId(userId) {
        this.policeManifestationGeneralState.userId = userId;
    }
    set ocularInspection(ocularInspection) {
        this.policeManifestationGeneralState.ocularInspection = ocularInspection;
    }
    set eyeInspectionResult(eyeInspectionResult) {
        this.policeManifestationGeneralState.eyeInspectionResult = eyeInspectionResult;
    }
    set samplesInvolved(samplesInvolved) {
        this.policeManifestationGeneralState.samplesInvolved = samplesInvolved;
    }
    set sampleTypes(sampleTypes) {
        this.policeManifestationGeneralState.sampleTypes = sampleTypes;
    }
    set weaponsIntervene(weaponsIntervene) {
        this.policeManifestationGeneralState.weaponsIntervene = weaponsIntervene;
    }
    set typesWeapons(typesWeapons) {
        this.policeManifestationGeneralState.typesWeapons = typesWeapons;
    }
    set armsWithdrawalProcedure(armsWithdrawalProcedure) {
        this.policeManifestationGeneralState.armsWithdrawalProcedure = armsWithdrawalProcedure;
    }
    set interestingData(interestingData) {
        this.policeManifestationGeneralState.interestingData = interestingData;
    }
    set transferHealthCenter(transferHealthCenter) {
        this.policeManifestationGeneralState.transferHealthCenter = transferHealthCenter;
    }
    set accompanyAddressEffects(accompanyAddressEffects) {
        this.policeManifestationGeneralState.accompanyAddressEffects = accompanyAddressEffects;
    }
    set accompanyFamilyHome(accompanyFamilyHome) {
        this.policeManifestationGeneralState.accompanyFamilyHome = accompanyFamilyHome;
    }
    set transferReceptionCenter(transferReceptionCenter) {
        this.policeManifestationGeneralState.transferReceptionCenter = transferReceptionCenter;
    }
    set observations(observations) {
        this.policeManifestationGeneralState.observations = observations;
    }
    set referralDate(referralDate) {
        this.policeManifestationGeneralState.referralDate = referralDate;
    }
    set numFoliosRemission(numFoliosRemission) {
        this.policeManifestationGeneralState.numFoliosRemission = numFoliosRemission;
    }
    set numReferralMinutes(numReferralMinutes) {
        this.policeManifestationGeneralState.numReferralMinutes = numReferralMinutes;
    }
    set independentMinutes(independentMinutes) {
        this.policeManifestationGeneralState.independentMinutes = independentMinutes;
    }
    set numCitations(numCitations) {
        this.policeManifestationGeneralState.numCitations = numCitations;
    }
    set citations(citations) {
        this.policeManifestationGeneralState.citations = citations;
    }
    set bodyTransfer(bodyTransfer) {
        this.policeManifestationGeneralState.bodyTransfer = bodyTransfer;
    }
    constructor(policeManifestationGeneralState) {
        this.policeManifestationGeneralState = policeManifestationGeneralState;
    }
    getState() {
        return this.policeManifestationGeneralState;
    }
}
